import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../components/componentsGeneral/AnimatedView/AnimatedView';
import DashboardContainer from '../../../components/componentsVisibility/Dashboard/DashboardContainer';

class visibilityDashboardView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }


    componentDidMount() {

    }

    render() {

        return (
            <AnimatedView>
                <DashboardContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection} />
            </AnimatedView>

        );
    }
}

export default visibilityDashboardView;
